import React from 'react'
import {Box, Button, Stack, Typography} from '@mui/material'
import type {SkillSelectionData} from './types'

interface SkillSelectionWidgetProps {
  data: SkillSelectionData
  onSubmit: (formattedMessage: string) => void
}

const SkillSelectionWidget: React.FC<SkillSelectionWidgetProps> = ({data, onSubmit}) => {
  return (
    <Box
      sx={{
        mx: 0,
        mb: 1,
        p: 2,
        border: 1,
        borderColor: 'primary.light',
        borderRadius: 2,
        bgcolor: 'background.paper',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
      }}
    >
      <Typography variant="body2" fontWeight={600} sx={{mb: 1.5}}>
        A few skills could help here — which would you like me to use?
      </Typography>

      <Stack spacing={1} sx={{mb: 1.5}}>
        {data.skills.map(skill => (
          <Box
            key={skill.name}
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'space-between',
              gap: 1.5,
              p: 1.5,
              border: 1,
              borderColor: 'divider',
              borderRadius: 1.5
            }}
          >
            <Box sx={{minWidth: 0}}>
              <Typography variant="body2" fontWeight={600}>
                {skill.name}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {skill.description}
              </Typography>
            </Box>
            <Button
              variant="contained"
              size="small"
              onClick={() => onSubmit(`Use the "${skill.name}" skill.`)}
              sx={{textTransform: 'none', flexShrink: 0}}
            >
              Use this
            </Button>
          </Box>
        ))}
      </Stack>

      <Button
        variant="text"
        size="small"
        onClick={() => onSubmit('Continue without using a skill.')}
        sx={{textTransform: 'none'}}
      >
        Continue without a skill
      </Button>
    </Box>
  )
}

export default SkillSelectionWidget
